module.exports = __webpack_public_path__ + "images/cebsb_logo.1791450974374.png";